<div class="modal-content">
    <div class="modal-header modal-">
      <h2>Cambiar objetivo y alcance</h2>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      ></button>
    </div>
    <form [formGroup]="form" (submit)="editarRevision()">
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 form-group">
              <label for="objetivo">Objetivo:</label>
              <textarea
                id="objetivo"
                name="objetivo"
                cols="40"
                rows="2"
                formControlName="objetivo"
                >{{ objetivo }}</textarea
              >
            </div>
          </div>
  
          <div class="row">
            <div class="col-md-12 form-group">
              <label for="alcance">Alcance:</label>
              <textarea
                id="alcance"
                name="alcance"
                cols="40"
                rows="2"
                formControlName="alcance"
                >{{ alcance }}</textarea
              >
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="form.invalid || btnDisabled" type="submit" class="btn btn-primary primary">Guardar</button>
      </div>
    </form>
  </div>
  